(function () {
    // allowed domains: currently, only our own subdomains
    const allowedDomains = [/^.*?\.donorschoose\.org/];

    function verifyOrigin(origin) {
        for (let i = 0; i < allowedDomains.length; i++) {
            if (origin.match(allowedDomains[i])) {
                return true;
            }
        }
        return false;
    }

    function handleRequest(event) {
        if (event.data === 'unblock-request' || event.data === 'unblock') {
            // Defined in clickjacking.js
            window.receiveMessage(event);
        } else if (verifyOrigin(event.origin)) {
            try {
                const data = JSON.parse(event.data);

                if (data && data.action) {
                    let action = data.action;
                    try {
                        if (action.includes('.')) {
                            action = action.replace('window.', '');
                            action.split('.').reduce((o, i) => o[i], window)(data);
                        } else {
                            // noinspection JSValidateTypes
                            window[action](data);
                        }
                    } catch (e) {
                        console.log(e.message);
                    }
                }
            } catch (e) {
                // console.log(e + " " + event.data);
            }
        }
    }

    window.addEventListener('message', handleRequest, false);
})();
